// AI-extractie van leveranciersvoorwaarden uit vrije tekst (geplakt of uit een
// tekstbestand). Loopt via de server-side AI-proxy (/ai/complete). Gemini 2.5 Flash;
// thinking-tokens tellen mee in max_tokens, dus ruim zetten.

import { aiComplete } from './ai-complete';

const MAX_TOKENS = 8192;

export interface ExtractedTerms {
  min_order_value: number | null;
  transport_cost_below_min: number | null;
  order_lead_time_days: number | null;
  terms_text: string;
}

const SYSTEM_PROMPT = `Je haalt leveranciersvoorwaarden uit losse tekst voor een inkoopsysteem. Antwoord ALLEEN met JSON, exact deze keys:
{
  "min_order_value": number of null,            // minimum orderbedrag in euro voor franco levering
  "transport_cost_below_min": number of null,   // transportkosten als de order onder het minimum blijft
  "order_lead_time_days": number of null,       // minimale levertijd in DAGEN (reken 48 uur = 2)
  "terms_text": string                          // de voorwaarden netjes opgeschoond als platte tekst
}
Regels: getallen als nummers zonder valuta-teken. Onbekend = null. Geen markdown, geen uitleg buiten het JSON-object.`;

export async function extractSupplierTerms(rawText: string): Promise<ExtractedTerms> {
  const content = await aiComplete({
    messages: [
      { role: 'system', content: SYSTEM_PROMPT },
      { role: 'user', content: rawText.slice(0, 12000) },
    ],
    json: true,
    temperature: 0.1,
    max_tokens: MAX_TOKENS,
  });

  const parsed = parseJson(content);
  return {
    min_order_value: numOrNull(parsed.min_order_value),
    transport_cost_below_min: numOrNull(parsed.transport_cost_below_min),
    order_lead_time_days: numOrNull(parsed.order_lead_time_days),
    terms_text: typeof parsed.terms_text === 'string' ? parsed.terms_text.trim() : rawText.trim(),
  };
}

function numOrNull(v: unknown): number | null {
  if (typeof v === 'number' && Number.isFinite(v)) return v;
  if (typeof v === 'string') {
    const n = parseFloat(v.replace(',', '.').replace(/[^\d.-]/g, ''));
    return Number.isFinite(n) ? n : null;
  }
  return null;
}

function parseJson(raw: string): Record<string, unknown> {
  const attempts = [raw.trim()];
  const fence = raw.match(/```(?:json)?\s*([\s\S]*?)\s*```/i);
  if (fence?.[1]) attempts.push(fence[1].trim());
  const first = raw.indexOf('{');
  const last = raw.lastIndexOf('}');
  if (first >= 0 && last > first) attempts.push(raw.slice(first, last + 1));
  for (const c of attempts) {
    try {
      return JSON.parse(c);
    } catch {
      // volgende
    }
  }
  throw new Error('AI-response niet als JSON parsebaar');
}
